import { ToppingBoxesList } from '../topping-boxes-list';

function MenuSearchToppingList({ toppings = [] }) {
  return <ToppingBoxesList toppings={toppings} />;
}

export default MenuSearchToppingList;
